<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true"/>
				<div class="card" v-if="asyncDone === false">
					<!-- Show the loader when async operation is going on -->
					<div class="loader"></div>
				</div>
			</div>
			<div class="col-12" v-if="asyncDone">
				<div class="card">
					<div class="card-header mt-3">
						<h4 class="card-title d-inline-block ml-4">Notifications & Announcements</h4>
					</div>
					<div class="card-body pl-5 pr-5">
						<div class="table-responsive">
							<table class="table notification-table">
								<thead class="text-primary">
									<tr>
										<th>Notifications</th>
										<th>From</th>
										<th class="text-center">Type</th>
										<th class="text-center">Created</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="notification in filteredNotifications" :key="notification.docID">
										<td>
											<span v-if="notification.read" class="badge badge-default mr-2">Read</span>
											<span v-html="notification.message"></span>
										</td>
										<td>{{ notification.from.name }}</td>
										<td class="text-center">
											<span class="badge badge-pill" :class="getStatusClass(notification.type)">
												{{notification.type}}
											</span>
										</td>
										<td  class="text-center">{{ (notification.createdAt) | fromNow  }}</td>
									</tr>
								</tbody>
							</table>
							<div class="center">
								<ul class="pagination pagination-primary"></ul>
							</div>
						</div>
<!--						<hr/>-->
						<div class="table-responsive">
							<table class="table announcement-table">
								<thead class="text-primary">
								<tr>
									<th>Announcements</th>
								</tr>
								</thead>
								<tbody>
									<tr v-for="announcement in announcements" :key="announcement.id" v-if="announcement.id !== 'deployed' || user.userType !== 'normal'">
										<td>
											<span v-html="announcement.text"></span>
											<small>Created At: <b>{{announcement.createdAt | formatDate}}</b> </small>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="center">
								<ul class="pagination pagination-primary"></ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal-component>
			<template v-slot:title>
				Request add to collaborator
			</template>
			<template v-slot:body>
				User send request yout to collaborator
			</template>
			<template v-slot:footer>
				<button  class="btn btn-success pull-left" :disabled="loading" @click.prevent="requestEvent('accepted')">
					<div class="loader small_loader" style="width: 20px; height: 20px;" v-if="loading && action === 'accept'"></div>
					<span v-else>Accept</span>
				</button>
				<button  class="btn btn-danger pull-right"  :disabled="loading"  @click.prevent="requestEvent('rejected')">
					<div class="loader small_loader" style="width: 20px; height: 20px;" v-if="loading && action === 'reject'"></div>
					<span v-else>Reject</span>
				</button>
			</template>
		</modal-component>
	</div>
</template>

<script>
	import {db, functions} from "@/firebase/init";
	import notificationMixin from "../../../../mixins/notificationMixin";
	import swal from "sweetalert2";

	export default {
		name: "NotificationList",
		mixins: [notificationMixin],
		components: {
			Alert: () =>
				import(/* webpackChunkName: "alert" */ "../../../../components/Alerts.vue"),
			ModalComponent: () =>
				import(/* webpackChunkName: "ModalComponent" */ "../../../../components/ModalComponent"),
		},
		data() {
			return {
				loading: false,
				action: null,
				tickets: [],
				pageCount: null,
				selectedPage: 0,
				events: {
					'ADD_TO_COLLABORATOR': {
						'name': 'Add to collaborator',
						'functionName': 'addCollaborator'
					}
				},
				event: null,
				announcements: []
			}
		},
		computed: {
			UID(){
				return this.$store.getters.getUID;
			},
			user() {
				return this.$store.getters.user;
			},
			asyncDone() {
				return this.$store.getters["async/state"];
			},
			alertType() {
				return this.$store.getters["alert/type"];
			},
			alertMessage() {
				return this.$store.getters["alert/message"];
			},
			alertShow() {
				return this.$store.getters["alert/show"];
			},
			notifications() {
				return this.$store.getters['notification/notificationList'];
			},
      filteredNotifications () {
			  return this.notifications.filter( (notification) => {
          return notification.message && notification.message !== ''
        })
      }
		},
		methods: {
			markAsRead(notification){
				this.action = `read_${notification.docID}`;
				this.loading = true;
				this.$store.dispatch('notification/updateNotification', {UID: this.UID,docID: notification.docID})
					.finally(()=>{
						this.action = null;
						this.loading = false;
					});
			},
			remove(notification){
				this.action = 'delete';
				this.loading = true;
				this.$store.dispatch('notification/removeNotification', {docID: notification.docID})
					.finally(()=>{
						this.action = null;
						this.loading = false;
					});
			},
			eventSubmit: function (notification) {
				this.event = {...this.events[notification.event], ...notification};
				this.$store.dispatch('updateModalVisible', true);
			},
			requestEvent(type){
				this.action = type;
				this.loading = true;
				const {from, docID} = this.event;
				if(!this.event){
					return false;
				}

				let status = false;
				if(type === 'accepted'){
					status = true;
				}

				const request = functions.httpsCallable(
					this.event.functionName
				);
				request({
					superviserId: from.id,
					collaboratorId:  this.user.uid,
					name: `${this.user.firstName} ${this.user.lastName}`,
					status: status
				})
					.then((request) => {
						if(request.data.message != 'success'){
							throw new Error(request.data.message)
						}
						swal({
							title: "Send a request to the collaborator",
							text: "Successfully send a request to the collaborator",
							type: "success",
							confirmButtonText: "OK",
							confirmButtonColor: "#6ACF98"
						});
						this.action = null;
						this.loading = false;
						this.$store.dispatch('notification/updateNotification', {
							docID
						});
						this.$store.dispatch('updateModalVisible', false);
					})
					.catch(() => {
						swal({
							title: "Something went wrong!",
							text: "Please try again",
							type: "error",
							confirmButtonText: "Try Again!",
							confirmButtonColor: "#EE8057"
						});
						this.action = null;
						this.loading = false;
					})
			},
		},
		updated() {


		},
		mounted () {
			this.announcements = [];
			const announcementQuery = db.collection('announcements').orderBy('createdAt', "desc").limit(100);
			announcementQuery.get().then(docs => {
				let ann = [];
				docs.forEach(doc => {
					ann.push({id: doc.id, ...doc.data()});
				});
				this.announcements = ann;
			})
		},
		created() {
			// TODO:: resolve pagination
			this.$store.dispatch("async/stateUpdate", { state: false });
			this.$store.dispatch('notification/fetchListNotification', {limit: 100, UID: this.UID})
				.then(() => {
					/* eslint-disable */
					$(function () {
						$(".notification-table").DataTable({
							ordering: false, lengthChange:false, destroy: true, deferRender: true,
							language: {
								search: "_INPUT_",
								searchPlaceholder: "Search In Notifications",
								emptyTable: "No Notification Exist!",
								size: '100'
							}
						});
						$(".announcement-table").DataTable({
							ordering: false, lengthChange:false, destroy: true, deferRender: true,
							language: {
								search: "_INPUT_",
								searchPlaceholder: "Search In Announcements",
								emptyTable: "No Announcement Exist!",
								size: '100'
							}
						});
					});
					/* eslint-enable */
					this.$store.dispatch("async/stateUpdate", { state: true })
				});
		}
	};
</script>
